export const appStoreLink = `https://apps.apple.com/app/yapmapapp/id1462299890?l=${window.navigator.language}`
export const unitLink = `https://shortbe.com/KzGY`

export const googlePlayLink =
  'https://play.google.com/store/apps/details?id=com.yapmap.yapmap'

export const stripeDonationLink = 'https://donate.stripe.com/8wMbJa2gk6d7d5CeUU'

export const contactMailLink = 'contact@relagram.app'
